export const SET_SPA_POS_STEP_DATA = "SET_SPA_POS_STEP_DATA"
export const SPA_RESTORE_JOB_DATA = 'SPA_RESTORE_JOB_DATA'
export const CLEAR_SPA_POS_STEP_DATA = 'CLEAR_SPA_POS_STEP_DATA'
